<template>
  <v-menu v-model="menu" min-width="330" max-width="330" allow-overflow z-index="1000" :close-on-content-click="false" top>
    <template v-slot:activator="{ on }">
      <div v-on="on">
        <span v-if="localMessageTags.length === 0"> clique para inserir ou criar um marcador </span>
        <v-row v-else-if="tagExtensiveName" no-gutters class="pa-0" justify="start">
          <span v-if="localMessageTags[0]" class="tag ma-1" :style="`background-color: ${localMessageTags[0].color};`">
            {{ localMessageTags[0].name }}
          </span>
          <span v-if="localMessageTags.length > 1" class="tag ma-1" :style="`background-color: ${localMessageTags[1].color};`">
            +{{ localMessageTags.length - 1 }}
          </span>
        </v-row>
        <v-row v-else no-gutters class="pa-0" justify="start">
          <span v-if="localMessageTags[0]" class="tag ma-1" :style="`background-color: ${localMessageTags[0].color};`">
            {{ localMessageTags[0].name }}
          </span>
          <span v-if="localMessageTags[1]" class="tag ma-1" :style="`background-color: ${localMessageTags[1].color};`">
            {{ localMessageTags[1].name }}
          </span>
          <span v-if="localMessageTags.length > 2" class="tag ma-1" :style="`background-color: ${localMessageTags[2].color};`">
            +{{ localMessageTags.length - 2 }}
          </span>
        </v-row>
      </div>
    </template>
    <v-card>
      <v-container class="pb-0 pt-1 px-0">
        <v-row ref="selectionList" class="tags-content-selection" no-gutters>
          <v-col>
            <v-row v-for="(tag, index) of localTagList" :key="index" no-gutters class="py-1 px-3">
              <span class="tag" :style="`background-color: ${tag.color};`" @click="selectTag(tag)">{{ tag.name }}</span>
              <v-spacer />
              <edit-tag :tags="localTagList" :tag="tag" @update-tag="updateTag($event)" @delete-tag="deleteTag(tag)" />
            </v-row>
            <v-row v-if="localTagList.length === 0" class="label-tag-list py-1 px-3" no-gutters>
              <v-col>
                <span class="texto-corrido pt-4">Enter para criar um novo marcador.</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="input-selected-tags pa-0" no-gutters>
          <v-col class="pa-0">
            <v-text-field
              v-model="inputSearch"
              autofocus
              flat
              solo
              maxlength="30"
              background-color="cinza-l90"
              placeholder="Digite para buscar ou criar um marcador"
              single-line
              hide-details
              @keyup.enter="createTag()"
            />
            <v-row ref="selectedList" class="tags-content-selected pr-2" no-gutters>
              <v-col class="flex-wrap">
                <span
                  v-for="(tag, index) of localMessageTags"
                  :key="index"
                  class="tag ml-3 mb-2"
                  :style="`background-color: ${tag.color};`"
                  @click="dropTag(tag)"
                >
                  {{ tag.name }}
                  <mf-icon x-small>close</mf-icon>
                </span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-menu>
</template>

<script>
import { MUTATION_CREATE_UPDATE_TAG, MUTATION_DELETE_TAG, MUTATION_CREATE_UPDATE_MESSAGE } from '@/modules/configuracoes/template-mensagens/graphql'
import { sample } from 'lodash'

export default {
  name: 'MessageTags',
  components: {
    EditTag: () => import('./EditTag.vue'),
  },
  props: {
    templateTags: {
      type: Array,
      default: () => [],
    },
    allTags: {
      type: Array,
      default: () => [],
    },
    template: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    inputSearch: '',
    localTagList: [],
    loading: false,
    menu: false,
  }),
  computed: {
    localMessageTags: {
      set(value) {
        this.$emit('update:templateTags', value)
      },
      get() {
        return this.templateTags ? this.templateTags.filter((tag) => tag) : []
      },
    },
    tagExtensiveName() {
      return this.localMessageTags[0]?.name.length > 15 || this.localMessageTags[1]?.name.length > 15
    },
    tagList() {
      return this.allTags
    },
    colors() {
      return [
        '#ffebee',
        '#ffcdd2',
        '#e8f5e9',
        '#c8e6c9',
        '#a5d6a7',
        '#b9f6ca',
        '#69f0ae',
        '#00e676',
        '#fce4ec',
        '#f8bbd0',
        '#f3e5f5',
        '#e1bee7',
        '#ede7f6',
        '#d1c4e9',
        '#e8eaf6',
        '#c5cae9',
        '#e3f2fd',
        '#bbdefb',
        '#e1f5fe',
        '#b3e5fc',
        '#81d4fa',
        '#4fc3f7',
        '#80d8ff',
        '#e0f7fa',
        '#b2ebf2',
        '#80deea',
        '#26c6da',
        '#84ffff',
        '#18ffff',
        '#00e5ff',
        '#e0f2f1',
        '#b2dfdb',
        '#a7ffeb',
        '#64ffda',
        '#1de9b6',
        '#f1f8e9',
        '#dcedc8',
        '#c5e1a5',
        '#aed581',
        '#9ccc65',
        '#ccff90',
        '#b2ff59',
        '#64dd17',
        '#f9fbe7',
        '#f0f4c3',
        '#e6ee9c',
        '#dce775',
        '#d4e157',
        '#cddc39',
        '#c0ca33',
        '#f4ff81',
        '#eeff41',
        '#c6ff00',
        '#aeea00',
        '#fffde7',
        '#fff9c4',
        '#fff59d',
        '#fff176',
        '#ffee58',
        '#ffeb3b',
        '#fdd835',
        '#fbc02d',
        '#ffff8d',
        '#ffff00',
        '#ffd600',
        '#fff8e1',
        '#ffecb3',
        '#ffe082',
        '#ffd54f',
        '#ffca28',
        '#ffc107',
        '#ffe57f',
        '#ffd740',
        '#ffc400',
        '#fff3e0',
        '#ffe0b2',
        '#ffcc80',
        '#ffd180',
        '#fbe9e7',
        '#ffccbc',
        '#ffab91',
        '#efebe9',
        '#d7ccc8',
      ]
    },
  },
  watch: {
    inputSearch: {
      handler(value) {
        if (value.trim()) {
          this.localTagList = this.tagList.filter((tag) => tag.name.toLowerCase().includes(value.toLowerCase()))
        } else {
          this.localTagList = this.tagList
        }
      },
      immediate: true,
    },
    tagList(value) {
      this.localTagList = value
    },
    async menu() {
      if (!this.menu) {
        await this.updateMessageTags()
        this.$emit('on-close')
      }
    },
  },
  methods: {
    async updateMessageTags() {
      const { _id, message, channels, from_campaign } = this.template
      const tagIds = this.localMessageTags.map((tag) => tag._id)
      const data = { _id, message, tags: tagIds, channels, from_campaign }
      await this.$apollo.mutate({
        mutation: MUTATION_CREATE_UPDATE_MESSAGE,
        variables: {
          data,
        },
      })
    },
    async createTag() {
      if (!this.inputSearch.trim()) return
      const currentAdded = this.tagList.find((item) => item.name.toLowerCase() === this.inputSearch.toLowerCase())
      if (currentAdded) return
      try {
        const newTag = {
          name: this.inputSearch,
          color: sample(this.colors),
        }
        const { _id } = await this.createOrUpdateTag(newTag)
        this.$emit('fetch-tags')
        this.selectTag({ ...newTag, _id })
        this.inputSearch = ''
      } catch (error) {
        console.log(error)
      }
    },
    async updateTag(updatedTag) {
      try {
        await this.createOrUpdateTag(updatedTag)
        this.$emit('fetch-tags')
        const index = this.localMessageTags.findIndex((item) => item._id === updatedTag._id)
        if (index > -1) this.localMessageTags[index].name = updatedTag.name
      } catch (error) {
        console.log(error)
      }
    },
    async createOrUpdateTag(tag) {
      let data = { name: tag.name, color: tag.color }
      if (tag._id) data = { ...data, _id: tag._id }
      const {
        data: { upsertTemplateTag },
      } = await this.$apollo.mutate({
        mutation: MUTATION_CREATE_UPDATE_TAG,
        variables: { data },
      })
      return upsertTemplateTag
    },
    async deleteTag(tag) {
      const { _id } = tag
      try {
        await this.$apollo.mutate({
          mutation: MUTATION_DELETE_TAG,
          variables: { _id },
        })
        const index = this.localMessageTags.findIndex((item) => item._id === tag._id)
        this.localMessageTags.splice(index, 1)
        this.$emit('fetch-tags')
      } catch (error) {
        console.log(error)
      }
    },
    async selectTag(tag) {
      const currentAdded = this.localMessageTags.find((item) => item._id === tag._id)
      if (currentAdded) return
      const newTags = [...this.localMessageTags, tag]
      this.localMessageTags = newTags
    },
    async dropTag(tag) {
      const index = this.localMessageTags.findIndex((item) => item._id === tag?._id)
      if (index < 0) return
      this.localMessageTags.splice(index, 1)
      this.$emit('fetch-tags')
    },
  },
}
</script>
<style lang="scss">
.input-selected-tags {
  background-color: $cinza-l90;
}

.flex-wrap {
  display: flex;
  flex-wrap: inherit;
}

.tags-content-selected {
  max-height: 184px;
  overflow-y: auto;
}

.tags-content-selection {
  @extend .tags-content-selected;
  height: 184px;
}

.label-tag-list {
  height: 100%;
  display: flex;
  align-items: flex-end;
}
</style>
